webpackJsonp([51],{

/***/ "4lUF":
/***/ (function(module, exports, __webpack_require__) {

var SectionVideoTime = (function () {
    SectionVideoTime.$inject = ["$stateParams"];
    function SectionVideoTime($stateParams) {
        this.$stateParams = $stateParams;
        this.currentVideoTime = 0;
        this.lastWistiaTime = 0;
        this.wistiaOptions = {
            volume: 0
        };
        this.wistiaCrosstimeListeners = [];
        this.ltTitle = this.$stateParams.t || this.ltTitle;
        this.description = this.$stateParams.d || this.description;
        this.introduceVideoShow = this.$stateParams.iv;
    }
    SectionVideoTime.prototype.$onDestroy = function () {
        this.unBindWistiaCrosstime();
    };
    SectionVideoTime.prototype.handlerWistiaModalClose = function () {
        this.introduceVideoShow = false;
        this.currentVideoTime = this.lastWistiaTime;
    };
    SectionVideoTime.prototype.changeVideoTime = function (timeStep) {
        this.setActive(timeStep);
        this.currentVideoTime = timeStep.time;
    };
    SectionVideoTime.prototype.setWistiaPlayer = function (video) {
        var _this = this;
        this.wistiaVideo = video;
        this.wistiaVideo.volume(this.wistiaOptions.volume);
        this.timeSteps.forEach(function (timeStep) { return _this.bindWistiaCrosstime(timeStep); });
    };
    SectionVideoTime.prototype.setActive = function (timeStep) {
        this.timeSteps.forEach(function (ts) { return ts.isActive = false; });
        timeStep.isActive = true;
        this.lastWistiaTime = timeStep.time;
    };
    SectionVideoTime.prototype.unBindWistiaCrosstime = function () {
        var _this = this;
        if (this.wistiaVideo) {
            this.wistiaCrosstimeListeners.forEach(function (o) { return _this.wistiaVideo.unbind('crosstime', o.time, o.fun); });
        }
    };
    SectionVideoTime.prototype.bindWistiaCrosstime = function (timeStep) {
        var _this = this;
        var bindFun = function () { return _this.setActive(timeStep); };
        this.wistiaCrosstimeListeners.push({
            fun: bindFun,
            time: timeStep.time
        });
        this.wistiaVideo && this.wistiaVideo.bind("crosstime", timeStep.time, bindFun);
    };
    return SectionVideoTime;
}());
angular.module('animatronApp.sectionVideoTime', []).component('sectionVideoTime', {
    bindings: {
        ltTitle: '<',
        description: '<',
        buttons: '<',
        video: '<',
        timeSteps: '<',
        background: '<',
        isScrollButton: '<'
    },
    controller: SectionVideoTime,
    templateUrl: __webpack_require__("Jul4")
});


/***/ }),

/***/ "Jul4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-video-time_08f7f6f9b46e5272bce93c55d09fa60e.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/51-28dc41a6a889e793a2e2.min.js